import * as React from "react";

import { PopularCategories } from "../../Common";

import { useReactMyBagInitialState } from "../providers";

export const MyBagEmptyState: React.FunctionComponent = () => {
  return (
    <section className="my-bag-empty-state">
      <section className="your-bag-is-currently-empty">
        <h4>{`Your bag is currently empty.`}</h4>
        <p>{`When you add items to your bag, they will appear here.`}</p>
      </section>

      <section className="elevate-your-home">
        <h2>
          <span>{`Ready to elevate your home?`}</span>
        </h2>

        <h5>{`Get inspired and start shopping below.`}</h5>

        <PopularCategories
          hideDefaultTitle
          useInitialState={useReactMyBagInitialState}
        />
      </section>
    </section>
  );
};
